// 全局变量

// 配置域名

const developmentEnvironment = 'https://mingiot.mindoutiot.com/web'; // 动态域名
// const developmentEnvironment = 'https://mingiot.mindoutiot.com/web_test'; // 动态域名

// const developmentEnvironment = 'http://localhost:13447'; // 动态域名
// const developmentEnvironment = 'http://47.114.187.140:13447'; // 动态域名
// const developmentEnvironment = 'http://172.28.30.226:13447'; // 动态域名

export default {
  developmentEnvironment
};




// WEBPACK FOOTER //
// ./src/assets/js/global_variable.js